import { pluralize } from "#app/lib/utils/pluralize";

/**
 * "3 members", "1 member" — and, with a cap, "999+ members" for a roster a
 * chip cannot spell out.
 */
export function memberCountLabel(count: number, options: { cap?: number } = {}): string {
  const shown =
    options.cap !== undefined && count > options.cap ? `${options.cap}+` : `${count}`;
  return `${shown} ${pluralize("member", { count })}`;
}
